import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getBurgerFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does burger food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: `What types of burgers can a burger food ${vehicleType} serve at my event?`,
    answer: `Classic cheeseburgers, smash burgers, wagyu, chicken sandwiches, and plant-based patties, usually with fries and a few sides. Many ${vehicleType}s make their own sauces and can set up a build-your-own topping bar.`
  },
  {
    question: `Are burger food ${vehicleType}s a good choice for corporate events and large groups?`,
    answer: `Yes. Burgers cook fast and need no explaining, which makes them a safe pick for mixed groups and tight lunch windows. Ask each ${vehicleType} how many guests it can serve per hour.`
  },
  {
    question: `Can burger food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Plant-based patties, lettuce wraps, and gluten-free buns are common. Note dietary needs in your request so the ${vehicleType}s that quote can plan for them.`
  },
  {
    question: `How far in advance should I book a burger food ${vehicleType} for catering?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  }
];

function BurgerFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getBurgerFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default BurgerFaq;
